import React from 'react';
import { ContentSpacer } from './generic-content-spacer';
import { WysiwygWithReactLink } from '../wysiwyg-with-react-link';


interface Props {
    headerText: string;
    description?: string;
}
export const PageHeader = (props: Props) => {
    return (
        <>
            <ContentSpacer>

                <h1>{props.headerText}</h1>
            </ContentSpacer>

            <ContentSpacer hide={!props.description}>
                <WysiwygWithReactLink content={props.description}/>
            </ContentSpacer>
        </>

    );
};

PageHeader.defaultProps = {
    description: '',
};